import React from "react";
import { Text ,Tooltip } from "react_reusable_components";
import { TwoColumn } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const BreadCrumbContainerStyle = {
  mainStyle: { display: "flex", width: variables.fullWidth, flexWrap: "wrap" },
  leftSectionStyle: { width: variables.breadCrumbTextWidth },
  mainTextStyle: (length) => ({
    overflow: "hidden",
    width: `calc(100% / ${length})`,
    maxWidth: "fit-content",
    alignItems: "flex-start",
  }),
  labelStyle: (isNotLast) => ({
    textTransform: "capitalize",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: variables.fullWidth,
    color: isNotLast ? variables.grey2 : variables.textDefault,
    fontWeight: isNotLast
      ? variables.fontWeightNormal
      : variables.fontWeightBold,
  }),
};

const BreadCrumbContainer = ({ data }) => {
  return (
    <div style={BreadCrumbContainerStyle.mainStyle}>
      {data?.map((item, index) => {
        return (
          <TwoColumn
            style={BreadCrumbContainerStyle.mainTextStyle(data.length)}
            key={item}
            leftSectionStyle={BreadCrumbContainerStyle.leftSectionStyle}
            leftSection={
              <Text
                type="secondary"
                style={BreadCrumbContainerStyle.labelStyle(
                  index !== data.length - 1
                )}
              >
                <Tooltip placement="bottomLeft" title={ item }>
                  {item}
                </Tooltip>
              </Text>
            }
            rightSectionStyle={{ width: variables.smallWidth }}
            rightSection={
              <Text>
                &nbsp;
                {index !== data.length - 1 && "/"}
              </Text>
            }
          />
        );
      })}
    </div>
  );
};

export default BreadCrumbContainer;
